module.exports = __webpack_public_path__ + "static/4-011f90548419b77e4fe36e47419c0617.png";